import axios from "axios";
import { convertToFormData } from "@services/form-data-converter";
import { objectToQueryString } from "@services/query-string-parser";
import { useEnvironmentStore } from "@store/environment-store";

/**
 * Axio Caller - 支援 api_scope header
 *
 * 在前端請求時，透過 X-API-SCOPE header 傳遞 apiScope 給 server side
 * apiScope 從 Environment Store 統一管理，不再依賴 URL 路徑判斷
 */

const compact = (obj) =>
  Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null));

function getHeaders(apiScope, additionalHeaders = {}) {
  let env = null;
  try {
    env = useEnvironmentStore();
  } catch (error) {
    console.warn("Environment Store not initialized, using default values");
  }

  const finalApiScope = apiScope || env?.apiScope || "main";

  return compact({
    ...additionalHeaders,
    "X-API-SCOPE": finalApiScope,
    "X-Member-Id": env?.currentMemberId,
    "X-Admin-Id": env?.currentAdminId,
  });
}

export const get = ({ url, options = {}, apiScope }) => {
  const headers = getHeaders(apiScope);
  return axios.get(`${url}?${objectToQueryString(options)}`, { headers });
};

export const postApiForm = ({ url, type, form, options, apiScope }) => {
  return callApiForm({ method: "post", type, url, form, options, apiScope });
};

export const putApiForm = ({ url, type, form, options, apiScope }) => {
  return callApiForm({ method: "put", type, url, form, options, apiScope });
};

export const destroy = ({ url, apiScope }) => {
  const headers = getHeaders(apiScope);
  return axios.delete(url, { headers });
};

const callApiForm = ({ url, method, type, form, options = {}, apiScope }) => {
  return new Promise(async (resolve, reject) => {
    let apiData = {
      data: {
        type: type,
        attributes: form,
      },
    };

    let headers = getHeaders(apiScope);

    if (options.isFormData) {
      apiData = convertToFormData(apiData);
      delete headers["Content-Type"];
    } else {
      headers["Content-Type"] = "application/json";
    }

    try {
      const response = await axios({
        method: method,
        url: url,
        data: apiData,
        headers: headers,
      });

      resolve(response);
    } catch (errors) {
      console.error("axio-caller-error", errors);
      reject(errors);
    }
  });
};
